import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Проверяем, не является ли ошибка связанной с расширениями браузера
    const errorMessage = error?.message || '';
    const errorStack = error?.stack || '';
    const isBrowserExtensionError = 
      errorMessage.includes('MetaMask') ||
      errorMessage.includes('Failed to connect to MetaMask') ||
      errorMessage.includes('chrome-extension') ||
      errorStack.includes('chrome-extension') ||
      errorStack.includes('inpage.js');
    
    // Игнорируем ошибки от расширений браузера
    if (isBrowserExtensionError) {
      console.warn('Browser extension error ignored by ErrorBoundary:', errorMessage);
      return null; // Не показываем ошибку
    }
    
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Игнорируем ошибки от расширений браузера
    const errorMessage = error?.message || '';
    const errorStack = error?.stack || '';
    const isBrowserExtensionError = 
      errorMessage.includes('MetaMask') ||
      errorMessage.includes('Failed to connect to MetaMask') ||
      errorMessage.includes('chrome-extension') ||
      errorStack.includes('chrome-extension') ||
      errorStack.includes('inpage.js');
    
    if (!isBrowserExtensionError) {
      console.error('Error caught by boundary:', error, errorInfo);
    } else {
      console.warn('Browser extension error caught but ignored:', errorMessage);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ 
          padding: '20px', 
          textAlign: 'center',
          margin: '50px auto',
          maxWidth: '600px',
          background: '#fee2e2',
          border: '1px solid #dc2626',
          borderRadius: '8px'
        }}>
          <h2 style={{ color: '#dc2626' }}>⚠️ Произошла ошибка</h2>
          <p style={{ color: '#7f1d1d' }}>
            {this.state.error?.message || 'Неизвестная ошибка'}
          </p>
          <button 
            onClick={() => {
              this.setState({ hasError: false, error: null });
              window.location.reload();
            }}
            style={{
              marginTop: '20px',
              padding: '10px 20px',
              background: '#dc2626',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Обновить страницу
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

